module.exports = "/images/vendor/vue2vis/dist/minus.png?5a379c46656d7a393c8f1ab293e46def";